import { Typography } from "@mui/material";
import React, { ReactNode } from "react";

export interface IPanelTitleProp {
    title: string | ReactNode;
    classes?: string;
}

export const PanelTitle = ({ title, classes }: IPanelTitleProp) => (
    <Typography variant="h6" fontWeight={600}>
        {title}
    </Typography>
);
